import React, { useState } from 'react';
import axios from 'axios';
import { Mail } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const Line = ({ label, value, tone }) => (
  <div className="flex gap-2 text-sm">
    <span className="font-semibold w-28 shrink-0">{label}</span>
    <span style={{ color: tone }}>{value}</span>
  </div>
);

export function EmailHealthCheck({ token }) {
  const [to, setTo] = useState('team@schedulesofwork.com');
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const send = async () => {
    setBusy(true);
    setError('');
    setResult(null);
    try {
      const { data } = await axios.post(`${API_URL}/api/admin/email-test`, { to },
        { headers: token ? { Authorization: `Bearer ${token}` } : {}, withCredentials: true });
      setResult(data);
    } catch (err) {
      setError(err?.response?.data?.error || 'Test failed');
    } finally {
      setBusy(false);
    }
  };

  const ok = '#166534';
  const bad = '#B91C1C';
  return (
    <div className="card p-6 mb-6" data-testid="email-health-card">
      <div className="text-xs font-semibold uppercase tracking-wide mb-2" style={{ color: 'var(--color-muted)' }}>Email health check</div>
      <p className="text-sm mb-3" style={{ color: 'var(--color-muted)' }}>Sends a test email. Gmail is tried first, then Resend.</p>
      <div className="flex flex-wrap gap-3 items-center">
        <input className="input-styled" style={{ minWidth: 280 }} type="email" value={to} onChange={(e) => setTo(e.target.value)} data-testid="email-test-to-input" />
        <button className="btn-primary px-4 py-2 flex items-center gap-2" onClick={send} disabled={busy} data-testid="email-test-send-btn">
          <Mail className="w-4 h-4" /> {busy ? 'Sending…' : 'Send test email'}
        </button>
      </div>
      {error && <div className="p-3 mt-4 rounded-lg text-sm" style={{ background: '#FEE2E2', color: bad }} data-testid="email-test-error">{error}</div>}
      {result && (
        <div className="mt-4 p-4 rounded-lg space-y-2" style={{ background: 'var(--color-bg)' }} data-testid="email-test-result">
          <Line label="Result" tone={result.delivered ? ok : bad}
            value={result.delivered ? `Delivered via ${result.via === 'gmail' ? 'Gmail' : 'Resend'}` : 'Not delivered'} />
          <Line label="Gmail" tone={result.via === 'gmail' ? ok : bad} value={result.via === 'gmail' ? 'Working' : `Failed: ${result.gmail_error}`} />
          {result.via !== 'gmail' && (
            <Line label="Resend" tone={result.via === 'resend' ? ok : bad} value={result.via === 'resend' ? 'Working (used as fallback)' : `Failed: ${result.resend_error}`} />
          )}
          <Line label="Sent at" value={result.sent_at} />
        </div>
      )}
    </div>
  );
}
